import TradingLogoImg from "@/assets/trading.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const TradingLogo = (props: Props) => (
  <LogoImage imgSrc={TradingLogoImg} alt="Trading Logo" size="navbar" {...props} />
);
